import { useEffect } from 'react';

import ScrollObserver from '../../observers/ScrollObserver';

export const useScrollObserver = (anchorElement: HTMLElement | null, callback: (rect: DOMRect) => void) => {

    useEffect(() => {
        if (anchorElement) {
            ScrollObserver.subscribe(anchorElement, callback);
        }

        return () => (anchorElement ? ScrollObserver.unsubscribe(anchorElement) : undefined);
    }, [ anchorElement, callback ]);
};

export default useScrollObserver;
